import { nanoid } from './values/id.js';
export const DetailsForm = {
    label: 'Details',
    id: 'details',
    validate: () => true,
    extractProperties(props) {
        return props;
    }
};
export const OverrideForm = {
    label: 'Custom CSS',
    id: 'override',
    validate: () => true,
    extractProperties(props) {
        return { override: props.override };
    }
};
export function Details(details) {
    return {
        title: '',
        description: '',
        id: (details === null || details === void 0 ? void 0 : details.id) || nanoid(10),
        ...details
    };
}
/*
type Aspect<Type extends string> = {
  type: Type
}

export function Form<Type extends string, Label extends string, Props>(form: {
  id: Type
  label: Label
  extractProperties: (props: any) => Partial<Props>
  validate: (props: Partial<Props>) => boolean
  fieldset?: any
}) {
  return form
}
 */
//# sourceMappingURL=details.js.map